<template>
  <div>
    <form-field-select
      :label="label"
      v-model="value.id"
      @change="selectUpdated"
      :validation-errors="validationErrors"
    >
      <!--No custom field-->
      <option :value="null">None</option>

      <!--select existing campaigns-->
      <option
        v-for="campaign in campaigns"
        :key="campaign.id"
        :value="campaign.id"
      >{{ campaign.label }}
      </option>

      <!--create new custom field-->
      <optgroup label="Create">
        <option :value="0">New Campaign</option>
      </optgroup>
    </form-field-select>

    <form-field-select
      v-if="showNewCampaignFields"
      label="Campaign Channel"
      v-model="value.channel"
      class="ml-200"
      @chang="channelUpdated"
    >
      <option
        v-for="channel in ENUMS.CampaignChannelEnum"
        :key="channel.value"
        :value="channel.value"
      >{{ channel.label }}</option>
    </form-field-select>

    <!--new custom field label-->
    <form-field-input
      v-if="showNewCampaignFields"
      label="Campaign Label"
      v-model="value.label"
      class="ml-200"
      @change="labelUpdated"
    />
  </div>
</template>

<script>
export default {
  name: "LaunchControlCampaignSelect",
  props: {
    value: {},
    label: {
      type: String,
      required: true,
    },
    validationErrors: {
      type: [
        String,
        Array,
        undefined
      ]
    },
  },
  computed: {
    showNewCampaignFields() {
      return this.value.id === 0
    },
    campaigns() {
      return this.$store.getters.activeCampaigns;
    },
  },
  methods: {
    selectUpdated(value) {
      this.$emit("input", {
        id: value,
        channel: this.value.channel,
        label: this.value.label,
      });
    },
    channelUpdated(value) {
      this.$emit("input", {
        id: this.value.id,
        channel: value,
        label: this.value.label,
      });
    },
    labelUpdated(value) {
      this.$emit("input", {
        id: this.value.id,
        channel: this.value.channel,
        label: value,
      });
    }
  },
};
</script>

<style scoped>

</style>
